"use client";

import React from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../AnimatedSection';
import { useTranslation } from 'react-i18next';

const QualitySection = () => {
  const { t } = useTranslation();
  return (
    <section className="relative" id="quality">
      <motion.div 
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <div 
          style={{
            backgroundImage: "url('/images/quality/img-qualidade-1920.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "0% 20%",
            filter: "brightness(0.6)"
          }}
          className="w-full h-full"
        />
      </motion.div>
      
      <div className="relative z-10 container mx-auto px-6 py-24">
        <AnimatedSection delay={0.2} className="max-w-4xl mx-auto text-center text-white">
          <motion.h2 
            className="text-5xl font-bold mb-12"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            {t("quality.title")}
          </motion.h2>
          
          <div className="space-y-6 text-lg mb-12">
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              {t("quality.description1")}
            </motion.p>
            
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              {t("quality.description2")}
            </motion.p>
            
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              {t("quality.description3")}
            </motion.p>
          </div>

          <motion.div
            className="aspect-video rounded-lg overflow-hidden shadow-xl"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            id="video" 
          >
            <video
              src="/videos/filme-final.mp4"
              poster="/images/quality/img-qualidade-1920.jpg"
              controls
              preload="metadata"
              className="w-full h-full object-cover rounded-lg"
            />
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default QualitySection;
